module.exports = __webpack_public_path__ + "img/volvo_ckrw.1fbbfaff.svg";